import { i18n } from '@/plugins/i18n'
import { invertKeyValues } from '@/common/objects'
import { ConversionStatus, ConversionType } from '@/constants'

export const conversionStatusStr = (status) => {
    const statusStr = invertKeyValues(ConversionStatus)[status]

    return statusStr ? i18n.t(`conversion.statuses.${statusStr.toLowerCase()}`) : 'undefined'
}

export const conversionStatusColor = (status) => {
    const colors = {
        [ConversionStatus.PENDING]: 'warning',
        [ConversionStatus.APPROVED]: 'success',
        [ConversionStatus.REJECTED]: 'danger',
        [ConversionStatus.DUPLICATED]: 'secondary',
        [ConversionStatus.CHECK_REQUIRED]: 'secondary',
    }

    return colors[status] ? colors[status] : 'undefined'
}

export const conversionTypeStr = (type) => {
    const typeStr = invertKeyValues(ConversionType)[type]

    return typeStr ? i18n.t(`conversion.types.${typeStr.toLowerCase()}`) : 'undefined'
}